import commonApi from 'api/commonApi'

const api = { logout: commonApi.logout }

export default api